export default {
  text: {
    en: 'The address we have on file for you couldn’t be verified and your upcoming order has been placed on hold.',
  },
}
